export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-09.53487af4.jpg";